import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import CancellationReasonsService from '../../../services/CancellationReasonsService';
import Results from './Results';
import Toolbar from './Toolbar';

import { selector as UserSelector } from '../../../redux/ducks/user';

const useStyles = makeStyles((theme) => ({
  categoryTitle: {
    display: 'inline-block',
    marginRight: '1rem'
  },
  titleEditable: {
    fontSize: '2.18rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 500,
    lineHeight: 1.167,
    letterSpacing: '-0.24px',
    color: '#888',
    marginBottom: '.5rem',
  },
  saveIcon: {
    color: 'white',
  },
  editButton: {
    cursor: 'pointer'
  },
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CancellationReasonsView = () => {
  const classes = useStyles();
  const { user } = useSelector(UserSelector);
  const [cancellationReasons, setCancellationReasons] = useState([]);

  const getCancellationReasons = async () => {
    const response = await CancellationReasonsService.getAll();

    if (response?.code === 200 && response?.data?.length > 0) {
      setCancellationReasons(response?.data);
    }
  };

  const refresh = async () => {
    if (user?.id) {
      await getCancellationReasons();
    }
  };

  useEffect(() => {
    if (user?.id) {
      getCancellationReasons();
    }
  }, [user]);

  return (
    <Page
      className={classes.root}
      title="Razones de cancelación"
    >
      <Container maxWidth={false}>
        <Toolbar refresh={refresh} />
        <Box mt={3}>
          <Results data={cancellationReasons} onRefresh={refresh} />
        </Box>
      </Container>
    </Page>
  );
};

export default CancellationReasonsView;
